import { createStore, applyMiddleware } from 'redux';
// import { createLogger } from 'redux-logger';
import { routerMiddleware } from 'react-router-redux'
import createHistory from 'history/createBrowserHistory'
import { createEpicMiddleware } from 'redux-observable';
import { composeWithDevTools } from 'redux-devtools-extension';

import { rootReducer, rootEpic } from './rootRedux'
import { apolloClient } from './apolloClient'
export { apolloClient } from './apolloClient'
// import { persistStore, autoRehydrate } from 'redux-persist-immutable'
import { apiMethods } from '../api/merchandiseTpvApi'

// Create a history of your choosing (we're using a browser history in this case)
export const history = createHistory()
// Build the middleware for intercepting and dispatching navigation actions
const routingMiddleware = routerMiddleware(history)
// const loggerMiddleware = createLogger(); // initialize logger
// const testLogger = text => action$ => action$.map(action => {console.log(text, action); return action;});
const noLogger = action$ => action$;

export const epicMiddleware = (dependencies) => createEpicMiddleware(rootEpic, {
    adapter: {
      // input: testLogger('INPUT ACTION: '),
      input: noLogger,
      // output: testLogger('OUTPUT ACTION: ')
      output: noLogger
    },
    dependencies
  }
);
// export const epicMiddleware = createEpicMiddleware(rootEpic);

const composeEnhancers = composeWithDevTools({
  // Specify here name, actionsBlacklist, actionsCreators and other options if needed
});

const configureStore = (dependencies) => (initialState) => {
  const store = createStore(
    rootReducer
    , initialState
    , composeEnhancers(
      applyMiddleware(
        routingMiddleware // apply our middleware for navigating
        // , loggerMiddleware // apply logger to redux
        , epicMiddleware(dependencies) // apply async reactive middleware
        , apolloClient.middleware()
      ),
      // other store enhancers if any
      // autoRehydrate()
    ));

    //The following two lines are needed in order to do testing with localStorage module enabled
   // if (typeof process === 'object' && process.title==='browser')
   //    persistStore(store) //we don't want to persist on node environment

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./rootRedux', () => {
      const nextReducer = require('./rootRedux');
      store.replaceReducer(nextReducer);
    });
  }
  return store;
}
export default configureStore(apiMethods);
export const configureStoreWithDependencies = (dependencies) => configureStore(dependencies);



// WEBPACK FOOTER //
// ./src/redux/configureStore.js